const { createBaseUserActionEvent } = require('./base');

const UserActionsMixpanelEvents = {
    clickedOnTranslationButton: createBaseUserActionEvent,
    clickedOnCancelledTranslationButton: createBaseUserActionEvent
};

module.exports = {
    UserActionsMixpanelEvents
};
